import api from '../../utils/api'

export const state = {
}

export const mutations = {
}

export const actions = {
  async handleCreate(_, body) {
    try {
      return await api.post('/frequently-asked-questions', body)
    } catch (e) {

    }
  },

  async handleUpdate(_, body) {
    try {
      return await api.put(`/frequently-asked-questions/${body._id}`, body)
    } catch (e) {

    }
  },

  async handleGet(_, _id) {
    try {
      return await api.get(`/frequently-asked-questions/${_id}`)
    } catch (e) {

    }
  },
  async handleDelete(_, _id) {
    try {
      return await api.delete(`/frequently-asked-questions/${_id}`)
    } catch (e) {

    }
  },

  async handlePagedList(_, payload) {
    try {
      let params = {}
      if (payload) {
        params = {
          categoryId: payload.categoryId || '',
          filter: payload.filter || '',
          page: payload.page || 1,
          limit: payload.limit || 10
        }
      }
      const { data: response } = await api.get('/frequently-asked-questions', { params })
      return response
    } catch (e) {

    }
  }
}

export const getters = {
}
